/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const API_ROOT = process.env.API || '';

// Permit
export const treePermit = (id: string) => `${API_ROOT}/treepermit/facilities/${id}`;
export const treePermitTypes = (id: string, active: boolean) =>
    `${API_ROOT}/treepermit/facilities/${id}/permit-types?active=${active}`;
export const locationsEndpoint = () => `${API_ROOT}/treepermit/facilities`;

// Availability
export const availability = (id: string, year: string) =>
    `${treePermit(id)}/availability?year=${year}`;

// Season
export const seasons = (treePermitId: string, year: string) =>
    `${API_ROOT}/treepermit/facilities/${treePermitId}/seasons?year=${year}`;

// parent asset
export const recarea = (id: string) =>
    `${API_ROOT}/search?fq=entity_type%3Arecarea&fq=entity_id%3A${id}`;

// Reservations
export const reservationEndpoint = () => `${API_ROOT}/treepermit/reservations`;
export const reservationByIdEndpoint = (id: string) =>
    `${API_ROOT}/treepermit/reservations/${id}`;
export const reservations = (permitId: string) =>
    `${API_ROOT}/treepermit/permit/${permitId}/issuances`;
export const reservation = (permitId: string, reservationId: string) =>
    `${reservations(permitId)}/${reservationId}`;
export const unpaidReservation = (permitId: string, reservationId: string) =>
    `${reservation(permitId, reservationId)}/unpaid`;

// price
export const priceEndpoint = () => `${API_ROOT}/treepermit/reservations/price`;

// validate

export const validateEndpoint = () => `${API_ROOT}/treepermit/reservations/validate`;

// search
export const searchPermitTypesEndpoint = () =>
    `${API_ROOT}/search?fq=entity_type%3Atreepermit&size=200`;
export const searchLocationsEndpoint = (criteria: string) =>
    `${API_ROOT}/search?q=${criteria}&fq=entity_type%3Atreepermit&size=200`;

//cspell:ignore treepermit, recarea, arecarea, ratingreview, atreepermit
